import RemoteCollection from "#root/utility/remote-collection";
import { z } from "zod";

export const GlobalUsageListItemSchema = z.array(z.union([z.string(), z.number()]));

export function getMonthlyGlobalUsageCollection(ymd: string) {
  return new RemoteCollection(`/api/usage/byMonth/${ymd}`, GlobalUsageListItemSchema, GlobalUsageListItemSchema);
}

export const UsageListItemSchema = z.object({
  name: z.string(),
  unit: z.string(),
  requests: z.number(),
});

export function getMonthlyUsageCollectionForDeployment(accountId: string, deploymentId: string, ymd: string) {
  return new RemoteCollection(`/api/account/${accountId}/deployment/${deploymentId}/usage/byMonth/${ymd}`, UsageListItemSchema);
}
